
export const CATAGORY1_LOADING = 'CATAGORY1_LOADING';
export const CATAGORY1_FAILED = 'CATAGORY1_FAILED';
export const ADD_CATAGORY1 = 'ADD_CATAGORY1';


export const CATAGORY2_LOADING = 'CATAGORY2_LOADING';
export const CATAGORY2_FAILED = 'CATAGORY2_FAILED';
export const ADD_CATAGORY2 = 'ADD_CATAGORY2';

export const CATAGORY3_LOADING = 'CATAGORY3_LOADING';
export const CATAGORY3_FAILED = 'CATAGORY3_FAILED';
export const ADD_CATAGORY3 = 'ADD_CATAGORY3';

export const POST_RATINGS = 'POST_RATINGS';
export const SHOW_RATINGS = 'SHOW_RATINGS';
export const ADD_RATINGS = 'ADD_RATINGS';
export const RATINGS_FAILED = 'RATINGS_FAILED';

